<span
  class="relative flex size-8.5 grow-0 items-center justify-center rounded-xl font-medium"
  [ngClass]="classes"
  [ngStyle]="styles"
  [sbTooltip]="tooltipTemplate"
  [sbTooltipMaxWidth]="'30rem'"
  [sbTooltipDisabled]="!absences.length"
>
  <span
    [ngClass]="{
      'underline decoration-2 underline-offset-2': day.isToday,
    }"
  >
    {{ day.monthDay }}
  </span>
  @if (absences.length > 1) {
    <sb-notification-badge
      class="absolute right-0 bottom-0 translate-x-1/2 translate-y-1/2"
      [count]="absences.length"
      [color]="'inverted'"
    />
  }
</span>

<ng-template #tooltipTemplate>
  <absence-tooltip [absences]="absences" [date]="day.date" />
</ng-template>
